// extracted by mini-css-extract-plugin
var _1 = "Select-module__animatedBackground--eu5_s";
var _2 = "Select-module__portal--tIRTZ";
var _3 = "Select-module__select--uGNPQ";
export { _1 as "animatedBackground", _2 as "portal", _3 as "select" }
